<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <img src="assets/ongoing_poll_icon.svg" class="icon-inline">
        <h3 class="bold header_title">ACTIVATION DE LA REPRISE DU VOTE</h3>
      </div>

      <div class="dark-blue" *ngIf="assessors.length > 0">
        <h2 class="text-md" style="margin: 5px 0px 5px 0px;">Saisir les clefs assesseurs</h2>
        <p class="text-md" style="margin: 5px 0px 5px 0px;">Entrez la clef à 6 chiffres de l’assesseur concerné. Les
          noms des
          trois assesseurs enregistrés sont affichés ci-dessous.</p>
      </div>

      <!-- Liste des assesseurs avec index -->
      <div>
        <div *ngFor="let assessor of assessors; let i = index" class="assessor-item">
          <div class="flex align-items-center" style="margin-bottom: 15px;">
            <p class="text-md dark-blue" style="margin-right: 10px;">{{i + 1}}.</p>
            <img *ngIf="!isAssessorActive(assessor.email)" src="assets/hourglass-icon.svg" class="icon-inline">
            <img *ngIf="isAssessorActive(assessor.email)" src="assets/done-icon.svg" class="icon-inline">
            <div style="flex: 1; margin-right: 20px;" class="ml-10">
              <p class="no-margin dark-blue text-md">{{assessor.name}}</p>
              <p class="no-margin text-sm dark-blue opacity-60">{{assessor.email}}</p>
            </div>
            <div class="flex flex-column">
              <div style="display: flex; justify-content: flex-start;" class="gap-10">
                <p-inputOtp [length]="6" [integerOnly]="true" styleClass="otp-input-custom"
                  [disabled]="isAssessorActive(assessor.email)" [(ngModel)]="otpCodes[i]"
                  (ngModelChange)="onCodeInput($event, i)" />
              </div>
              <p class="no-margin text-xs red">{{suspendErrorMessage[i]}}</p>
            </div>

          </div>
        </div>
      </div>

      <div>
        <h2 class="no-margin dark-blue text-md" style="margin: 13px 0px 5px 0px;">Message aux électeurs</h2>
        <p class="dark-blue" style="margin: 5px 0px 5px 0px;">Le message affiché aux électeurs lors de la suspension du
          vote sera automatiquement désactivé dès la reprise du scrutin.
        </p>
      </div>

      <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
        <button *ngIf="isResumeReady" type="button" class="action-button green-action-button" style="font-size: 16px; margin-top: 35px;"
          (click)=onDismiss(true)>Reprendre
        </button>
        <button *ngIf="!isResumeReady" type="button" class="action-button green-action-button inactive-green-button"
          style="font-size: 16px;">Reprendre
        </button>
        <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Annuler</p>
      </div>
    </div>
  </div>
</div>